export default __webpack_public_path__ + "static/media/LandingPageMockExams.e433562a.webp";